import {gql} from '@apollo/client';

const SCIENTIFIC_MODEL_METADATA_FRAGMENT = gql`
  fragment ScientificModelMetadata on ScientificModelNode {
    displayName
    systemName
    externalReference
    iconPath
    category
    description
    paperLink
    inputTypes
    canHaveProperties
    capabilities {
      supportsMultimers
      supportsMultimerMolecules
      msaSupport
      showMsaRecentlyAddedNotice
      egressesData
      supportsBulkPredictions
      isPreview
      minAminoAcidCount
      maxAminoAcidCount
      maxTokenCount
      maxMultimerComponents
      maxBulkPredictionItems
    }
    propertyDefinitions {
      key
      displayName
      groupingId
      role
      units
      description
      allowedValues
    }
  }
`;

export const GET_SCIENTIFIC_MODEL_REGISTRY_QUERY = gql`
  query GetScientificModelRegistry @skipAudit @engComponent(name: MODEL_HUB) {
    availableScientificModels: scientificModels {
      ...ScientificModelMetadata
    }
    scientificModelCatalog: scientificModels(includeUninstalled: true) {
      ...ScientificModelMetadata
    }
  }
  ${SCIENTIFIC_MODEL_METADATA_FRAGMENT}
`;
